import React from 'react';
import TierGrid from '../TierGrid';
import PopupInnerLayout from '../../_partials/PopupInnerLayout';
import LoadingIndicator from '../../../LoadingIndicator';
import { useTiers } from '../../_hocs/withTiers';
import { useCurrentTier } from '../../_hocs/withCurrentTier';
import { MeasuredCookieType } from '../../../Measured';
import TierPromotionCard from '../../../DeviationViews/TierPromotionCard';
var TierExplorer = function () {
    var _a = useTiers(), tiers = _a.tiers, isTierStreamInitialized = _a.isTierStreamInitialized, isFetchingTiers = _a.isFetchingTiers, hasMoreTiers = _a.hasMoreTiers, fetchMoreTiers = _a.fetchMoreTiers;
    var setCurrentTierId = useCurrentTier().setCurrentTierId;
    var onTierClick = function (tier) {
        setCurrentTierId(tier.deviationId);
    };
    var renderTier = function (_a) {
        var index = _a.index, width = _a.width;
        var tier = tiers[index];
        return (React.createElement(TierPromotionCard, { width: width, deviation: tier, onClick: onTierClick }));
    };
    var fetchMoreTiersIfNeeded = function () {
        if (!hasMoreTiers || isFetchingTiers) {
            return;
        }
        fetchMoreTiers();
    };
    var renderContent = function () {
        return (React.createElement(React.Fragment, null,
            isTierStreamInitialized && (React.createElement(TierGrid, { cookieType: MeasuredCookieType.GALLECTION_EXPLORER, tiers: tiers, tierRenderer: renderTier })),
            isFetchingTiers && (React.createElement(LoadingIndicator, { view: "daSymbol", coverMode: !tiers.length }))));
    };
    return (React.createElement(PopupInnerLayout, { scrollableContent: renderContent(), onScrolledToBottom: fetchMoreTiersIfNeeded, onNotScrollable: fetchMoreTiersIfNeeded }));
};
TierExplorer.displayName = 'TierExplorer';
export default TierExplorer;
//# sourceMappingURL=TierExplorer.js.map